import React, { useMemo, useContext, useState } from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useTranslation } from 'react-i18next';

const Default = () => {
    const { t } = useTranslation();

    const [filters, setFilters] = useState()


    const { userCapabilities } = useContext(AppContext);

    const now = new Date();
    const startPreviousYear = (now.getFullYear() - 1) + '-01-01';
    const startYear = now.getFullYear() + '-01-01';
    const startPreviousMonth = now.getFullYear() + '-' + String(now.getMonth()).padStart(2, '0') + '-01';
    const startMonth = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-01';

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">

            <KPI
                title="Total Accounts"
                icon="faEnvelopeCircleCheck"
                className="superuserData"
                dataProviderName={'zoho/account/statistic/total'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (newfilters) => setFilters({ filterModel: { ...newfilters } })
                }}
                filters={{
                    items: [{

                    }]
                }}
            />

            <KPI
                title={t("To be checked")}
                icon="faExclamationTriangle"
                dataProviderName={'zoho/account/statistic/checked'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (newfilters) => setFilters({ filterModel: { ...newfilters } })
                }}
                filters={{
                    items: [{

                    }]
                }}
            />
            <KPI
                title={t("Importable")}
                icon="faArrowUp"
                dataProviderName={'zoho/account/statistic/importable'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (newfilters) => setFilters({ filterModel: { ...newfilters } })
                }}
                filters={{
                    items: [{
                        field: "actions",
                        operator: "equals",
                        value: "create"
                    }]
                }}
            />
            <KPI
                title={t("Synched")}
                icon="faCheck"
                dataProviderName={'zoho/account/statistic/synced'}

            />


        </Box>
        <List />

    </>, [])

}

export default Default;


